import Subscriber from './Subscriber';

export default Subscriber;
